import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface RecoveryDialogProps {
  open: boolean;
  onResume: () => void;
  onClose: () => void;
}

export default function RecoveryDialog({ open, onResume, onClose }: RecoveryDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Recover unsaved changes?</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-muted-foreground">
          <p>A newer local draft was found from your last session. You can resume editing from the draft.</p>
        </div>
        <DialogFooter className="gap-2">
          <Button onClick={onResume} data-testid="recovery-resume-draft">Resume draft</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}


